import _isEmpty from 'lodash/isEmpty';
export function getItemName() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$includeQuantity = _ref.includeQuantity,
    includeQuantity = _ref$includeQuantity === void 0 ? false : _ref$includeQuantity;
  var _item$item_data = item.item_data,
    _item$item_data2 = _item$item_data === void 0 ? {} : _item$item_data,
    itemName = _item$item_data2.name,
    _item$item_variation_ = item.item_variation_data,
    _item$item_variation_2 = _item$item_variation_ === void 0 ? {} : _item$item_variation_,
    variationName = _item$item_variation_2.name,
    quantity = item.quantity;
  var finalName = '';
  if (includeQuantity && quantity && quantity > 1) {
    finalName += "".concat(quantity, " x ");
  }
  finalName += "".concat(itemName);
  if (!_isEmpty(variationName)) {
    finalName += " (".concat(variationName, ")");
  }
  return finalName;
}
export function getItemPhoto() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _item$item_data3 = item.item_data,
    _item$item_data4 = _item$item_data3 === void 0 ? {} : _item$item_data3,
    itemPhoto = _item$item_data4.photo,
    _item$item_variation_3 = item.item_variation_data,
    _item$item_variation_4 = _item$item_variation_3 === void 0 ? {} : _item$item_variation_3,
    variationPhoto = _item$item_variation_4.photo,
    photo = item.photo;
  return photo || itemPhoto || variationPhoto;
}